var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-loader-container"},[_c('div',{staticClass:"widget-loader-background",style:({
      '--loader-background': _vm.widgetColor,
    })}),_vm._v(" "),_c('div',{staticClass:"widget-loader-spinner",style:({
      '--loader-color': _vm.textColor,
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }